<script setup lang="ts">
const WARNING_TEXT = 'Сайт не работает';
const SEPARATOR = ' · ';

const tapeLabel = `${WARNING_TEXT}${SEPARATOR}`.repeat(60);
</script>

<template>
  <div
    class="warning-overlay"
    aria-hidden="true"
  >
    <div class="warning-overlay__strip warning-overlay__strip--1">
      <span class="warning-overlay__text">{{ tapeLabel }}</span>
    </div>
    <div class="warning-overlay__strip warning-overlay__strip--2">
      <span class="warning-overlay__text">{{ tapeLabel }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.warning-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  pointer-events: auto;
  overflow: hidden;
}

.warning-overlay__strip {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 200vmax;
  height: clamp(36px, 5vmin, 52px);
  display: flex;
  align-items: center;
  overflow: hidden;
  background-color: var(--clr-yellow);
  border-block: 3px solid var(--clr-text-primary);
  box-shadow: 0 2px 12px rgb(20 20 20 / 25%);
  transform-origin: center;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 10px,
      rgb(20 20 20 / 12%) 10px,
      rgb(20 20 20 / 12%) 20px
    );
    pointer-events: none;
  }

  &--1 {
    transform: translate(-50%, -50%) rotate(-32deg);
  }

  &--2 {
    transform: translate(-50%, -50%) rotate(32deg);
  }
}

.warning-overlay__text {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  padding-inline: 8px;
  color: var(--clr-text-primary);
  font: 900 clamp(12px, 2.8vmin, 18px) var(--font);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  white-space: nowrap;
}
</style>
